import { MutationTree } from 'vuex'
import { IDataState } from '@/store/data'
import {
  Types,
  Loading,
  Saving,
  Removing,
  Finished,
  Errors,
  Dialog,
  None,
  To,
  Clone,
  Saved,
  Message,
  Title,
  Button,
  Controller,
  ScrollHeight,
  OffsetHeight,
  ScrollTop,
  Checkin,
  Withdraw
} from '@/store/data/types'

const mutations: MutationTree<IDataState> = {
  [Types.loading]: (state, action: Loading) => {
    state.loading = action.payload
  },
  [Types.saving]: (state, action: Saving) => {
    state.saving = action.payload
  },

  [Types.removing]: (state, action: Removing) => {
    state.removing = action.payload
  },

  [Types.finished]: (state, action: Finished) => {
    state.finished = action.payload
  },

  [Types.errors]: (state, action: Errors) => {
    state.errors = action.payload === null ? {} : action.payload
  },

  [Types.dialog]: (state, action: Dialog) => {
    state.dialog = action.payload
  },

  [Types.none]: (state, action: None) => {
    state.none = action.payload
  },

  [Types.clone]: (state, action: Clone) => {
    state.clone = action.payload
  },

  [Types.saved]: (state, action: Saved) => {
    state.saved = action.payload
  },

  [Types.to]: (state, action: To) => {
    state.to = action.payload
  },

  [Types.message]: (state, action: Message) => {
    state.message = action.payload
  },

  [Types.title]: (state, action: Title) => {
    state.title = action.payload
  },

  [Types.button]: (state, action: Button) => {
    state.button = action.payload
  },

  [Types.controller]: (state, action: Controller) => {
    state.controller = action.payload
  },

  [Types.scrollHeight]: (state, action: ScrollHeight) => {
    state.scrollHeight = action.payload
  },

  [Types.offsetHeight]: (state, action: OffsetHeight) => {
    state.offsetHeight = action.payload
  },

  [Types.scrollTop]: (state, action: ScrollTop) => {
    state.scrollTop = action.payload
  },

  [Types.checkin]: (state, action: Checkin) => {
    state.checkin = action.payload
  },

  [Types.withdraw]: (state, action: Withdraw) => {
    state.withdraw = action.payload
  }
}

export default mutations
